import { useMemo } from 'react';
import type { VersionModel } from 'shared/domain/documentation/documentationModel';
import { LevelMapResolution, MapReference, resolveMap } from 'shared/domain/documentation/levelMap';
import { useMapDocumentation } from './useMapDocumentation';

/**
 * What a map shows and why it may not be drawn (PT-7117), kept current with its
 * documentation (see `useMapDocumentation`). A documentation that cannot be read
 * resolves as `unavailable`.
 * `undefined` while the map's documentation is read for the first time (also in the
 * render that switches to another map) or when there is no map.
 */
export function useMapResolution(map: MapReference | undefined): LevelMapResolution<VersionModel> | undefined {
  const { documentation, settled } = useMapDocumentation(map?.documentationId);
  const documentationId = map?.documentationId;
  const pinnedVersionId = map?.versionId;

  return useMemo(() => {
    if (!documentationId || !settled) {
      return undefined;
    }
    return resolveMap({ documentationId, versionId: pinnedVersionId }, () => documentation);
  }, [documentationId, pinnedVersionId, settled, documentation]);
}
